// Utility for loading permanent GeoJSON layers (Couloirs, etc.) for Mapbox GL JS
import { API_BASE_URL } from '../config';

export const permanentLayersGeojson = [
  {
    id: 'couloirs',
    name: 'Couloirs',
    url: `${API_BASE_URL}/api/layers/couloirs`,
    style: {
      fillColor: '#888888',
      fillOpacity: 0.3,
      lineColor: '#888888',
      lineWidth: 1
    },
    popupFields: [
      { key: 'Nom', label: 'Nom' },
      { key: 'Superficie', label: 'Superficie' },
      { key: "Type d'activité", label: "Type d'activité" },
      { key: 'Wilaya', label: 'Wilaya' },
      { key: 'Moughataa', label: 'Moughataa' },
      { key: "Date d'attribution", label: "Date d'attribution" },
      { key: 'Numéro arrêté', label: 'Numéro arrêté' }
    ]
  },
  {
    id: 'petite-mine',
    name: 'Permis petite mine',
    url: `${API_BASE_URL}/api/layers/petite-mine`,
    style: {
      fillColor: '#ffd700',
      fillOpacity: 0.2,
      color: '#000000',
      weight: 0.1
    },
    popupFields: [
      { key: 'Détenteur', label: 'Détenteur' },
      { key: 'Code', label: 'Code' },
      { key: "Date d'octroi", label: "Date d'octroi" },
      { key: "Date d'expiration", label: "Date d'expiration" },
      { key: 'Wilaya', label: 'Wilaya' },
      { key: 'Couloir', label: 'Couloir' },
      { key: 'Status', label: 'Status' },
      { key: 'Renouvellement', label: 'Renouvellement' },
      { key: 'Bornage', label: 'Bornage' },
      { key: 'Date NIE', label: 'Date NIE' },
      { key: 'Date demarrage des travaux', label: 'Date démarrage des travaux' },
      { key: 'Bulletin des travaux', label: 'Bulletin des travaux' },
      { key: 'Production', label: 'Production' }
    ],
    customHeader: true, // Enable custom header formatting
    headerFormat: (properties: any) => properties.Code ? `${properties.Code} D2` : 'PPEM'
  },
  {
    id: 'mejhars',
    name: 'Mejhars',
    url: `${API_BASE_URL}/api/layers/mejhars`,
    style: {
      fillColor: '#FF0000',
      fillOpacity: 1,
      color: '#000000',
      weight: 1
    },
    popupFields: [
      { key: 'Nom', label: 'Nom' },
      { key: 'Zone', label: 'Zone' },
      { key: 'Statut', label: 'Statut' },
      { key: 'Nombre d\'exploitants', label: 'Nombre d\'exploitants' },
      { key: 'Total puits', label: 'Total puits' },
      { key: 'Puits actifs', label: 'Puits actifs' },
      { key: 'Puits non actifs', label: 'Puits non actifs' },
      { key: 'Type d\'exploitation', label: 'Type d\'exploitation' },
      { key: 'Date debut d\'exploitation', label: 'Date début d\'exploitation' },
      { key: 'Succursale', label: 'Succursale' },
      { key: 'Accidents enregistrés', label: 'Accidents enregistrés' },
      { key: 'Date dernier recensement', label: 'Date dernier recensement' },
      { key: 'Coordonnées GPS', label: 'Coordonnées GPS' }
    ]
  },
  {
    id: 'forages',
    name: 'Forages',
    url: `${API_BASE_URL}/api/layers/forages`,
    style: {
      fillColor: '#87CEEB',
      fillOpacity: 1,
      color: '#000000',
      weight: 1
    },
    popupFields: [
      { key: 'Nom', label: 'Nom' },
      { key: 'Coordonnées', label: 'Coordonnées' },
      { key: 'Date', label: 'Date' },
      { key: 'Wilaya', label: 'Wilaya' },
      { key: 'Profondeur', label: 'Profondeur' },
      { key: 'Débit', label: 'Débit' },
      { key: 'Équipé', label: 'Équipé' },
      { key: 'Exploité par', label: 'Exploité par' }
    ]
  },
  {
    id: 'zones-commerciales',
    name: 'Zones commerciales',
    type: 'group',
    children: [
      {
        id: 'zone-commerciale-chami',
        name: 'Chami',
        url: `${API_BASE_URL}/api/layers/zone-commerciale-chami`,
        style: {
          fillColor: 'transparent',
          fillOpacity: 0,
          color: '#000000',
          weight: 1,
          lineOpacity: 1
        },
        popupFields: [
          { key: 'nom', label: 'Nom' },
          { key: 'type', label: 'Type' },
          { key: 'superficie', label: 'Superficie' }
        ]
      },
      {
        id: 'zone-commerciale-sfariyatt',
        name: 'Sfariyatt',
        url: `${API_BASE_URL}/api/layers/zone-commerciale-sfariyatt`,
        style: {
          fillColor: 'transparent',
          fillOpacity: 0,
          color: '#000000',
          weight: 1,
          lineOpacity: 1
        },
        popupFields: [
          { key: 'nom', label: 'Nom' },
          { key: 'type', label: 'Type' },
          { key: 'superficie', label: 'Superficie' }
        ]
      }
    ]
  }
  // Add more permanent layers here as needed
];

